import createApiRequester from '../../../api/apiRequester'
import environment from '../../../config'
import { NotificationModel } from '../types'

const requester = createApiRequester(environment.apis.notificationHub.v1)

const notificationHubService = {
  getNotifications: async (): Promise<NotificationModel[]> => {
    const result = await requester.get('notifications')

    if (!result.problem) return result.data as NotificationModel[]

    return Promise.reject(result.problem)
  },
}

export default notificationHubService
